/** @description Экшен для обновления списка резервов */
import { IAppActions } from '../../types/IAppActions';
import * as ActionTypes from './WebSocketActionsTypes';

export function socketEventReserveCreated(): IAppActions {
  return {
    type: ActionTypes.SOCKET_RESERVE_CREATED,
  };
}

// TODO Сейчас вызывает обновление списка резервов, после реализации фичи с новыми резервовом пересмотреть актуальность.
export function socketEventReserveConfirmation(): IAppActions {
  return {
    type: ActionTypes.SOCKET_RESERVE_CONFIRMATION,
  };
}

/** @description Экшен для переподключения вебсокета  */
export function socketReconnect(): IAppActions {
  return {
    type: ActionTypes.SOCKET_RECONNECT,
  };
}

/** @description Экшен для редактирования статуса вебсокета */
export function setSocketConnectStatus(isConnect: boolean) {
  return {
    type: ActionTypes.SET_SOCKET_CONNECT_STATUS,
    payload: {
      isConnect,
    },
  };
}

/** @description Экшен для отправки сообщения через вебсокет */
export function socketSendMessage(destination: string, payload: any, headers: any = {}): IAppActions {
  return {
    type: ActionTypes.SOCKET_SEND_MESSAGE,
    payload: {
      destination,
      payload,
      headers,
    },
  };
}

export const socketSubscribeMessengerAuth = () => ({
  type: ActionTypes.SOCKET_SUBSCRIBE_MESSENGER_AUTH,
});

export const socketUnsubscribeMessengerAuth = () => ({
  type: ActionTypes.SOCKET_UNSUBSCRIBE_MESSENGER_AUTH,
});
